export default __webpack_public_path__ + "static/media/twitter-icon-blue.fecdcbd8.svg";